/**
 * CINE Tool Events
 */
enum Events {
  CLIP_STOPPED = 'CORNERSTONE_CINE_TOOL_STOPPED',
  CLIP_STARTED = 'CORNERSTONE_CINE_TOOL_STARTED',
}

export default Events;
